import { __awaiter } from "tslib";
import { FacadeRegistry } from './facade-registry';
import { JWebWeb } from './web-runtime';
const augmentedGlobal = globalThis;
export const getGlobalJWeb = () => augmentedGlobal.JWeb;
export const isGlobalJWebSet = () => augmentedGlobal.JWeb !== undefined;
const setGlobalJWeb = (globalJWeb) => {
    augmentedGlobal.JWeb = globalJWeb;
};
export const getGlobalJWebRegistry = () => augmentedGlobal.JWebRegistry;
export const isGlobalJWebRegistrySet = () => augmentedGlobal.JWebRegistry !== undefined;
const setGlobalJWebRegistry = (globalJWebRegistry) => {
    augmentedGlobal.JWebRegistry = globalJWebRegistry;
};
const JWEB_READY_EVENT_TYPE = 'com.hp.jarvis.jweb.event.ready';
const READY_TIMEOUT_MS = 5;
const pluginsToRegister = new Map();
const flushQueuedPlugins = (jweb) => {
    if (pluginsToRegister.size === 0)
        return;
    pluginsToRegister.forEach((plugin, name) => {
        registerPlugin(name, plugin, jweb);
    });
    pluginsToRegister.clear();
};
const resolveJWeb = (resolve) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    console.log('global::resolveJWeb');
    let jweb = getGlobalJWeb();
    if (!jweb) {
        console.log('global::resolveJWeb: did not find global JWeb, will create web platform JWeb');
        jweb = new JWebWeb();
        flushQueuedPlugins(jweb);
    }
    try {
        yield FacadeRegistry.adaptJWeb(jweb);
    }
    catch (err) {
        console.error('resolveJWeb: adaptJWeb failed', err);
        // Proceed anyway with the best available instance
    }
    const globalNow = getGlobalJWeb();
    if (!globalNow) {
        console.log('global::resolveJWeb: did not find global JWeb, will set global JWeb');
        setGlobalJWeb(jweb);
    }
    console.log('global::resolveJWeb: ready!');
    resolve((_a = getGlobalJWeb()) !== null && _a !== void 0 ? _a : jweb);
});
let jWebReadyPromise;
export const getJWebReadyPromise = () => {
    console.log('global::jWebReady');
    if (jWebReadyPromise) {
        return jWebReadyPromise;
    }
    jWebReadyPromise = new Promise((resolve) => {
        var _a;
        if (isGlobalJWebSet()) {
            console.log('global::jWebReady: found global JWeb');
            void resolveJWeb(resolve);
            return;
        }
        console.log('global::jWebReady: did not find global JWeb, setting up listeners and timeout');
        let timeoutId;
        const onReady = (_event) => {
            console.log('global::jWebReady: received jWebReady event');
            cleanup(onReady);
            void resolveJWeb(resolve);
        };
        const cleanup = (listener) => {
            var _a;
            if (timeoutId) {
                clearTimeout(timeoutId);
                timeoutId = undefined;
            }
            (_a = augmentedGlobal.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(augmentedGlobal, JWEB_READY_EVENT_TYPE, listener);
        };
        (_a = augmentedGlobal.addEventListener) === null || _a === void 0 ? void 0 : _a.call(augmentedGlobal, JWEB_READY_EVENT_TYPE, onReady, { once: true });
        const timeoutCallback = () => {
            console.log('global::jWebReady: timeout reached, creating fallback JWeb');
            cleanup(onReady);
            resolveJWeb(resolve);
        };
        timeoutId = setTimeout(timeoutCallback, READY_TIMEOUT_MS);
    });
    return jWebReadyPromise;
};
const isEmptyPlainObject = (obj) => !!obj &&
    typeof obj === 'object' &&
    Object.getPrototypeOf(obj) === Object.prototype &&
    Object.keys(obj).length === 0;
export const registerPlugin = (name, plugin, jweb) => {
    var _a;
    console.log(`global::registerPlugin: called with name=${name}`);
    const target = jweb !== null && jweb !== void 0 ? jweb : getGlobalJWeb();
    if (!target) {
        const existing = pluginsToRegister.get(name);
        if (!existing) {
            console.log("global::registerPlugin: enqueued plugin ${name} for registration in JWeb");
            pluginsToRegister.set(name, plugin);
        }
        else if (existing !== plugin) {
            console.warn('global::registerPlugin:: plugin ${name} already enqueued with a different instance in JWeb');
        }
        else {
            console.log('global::registerPlugin: plugin ${name} already enqueued for registration in JWeb (same instance)');
        }
        return;
    }
    if (target.platform !== 'web') {
        console.warn(`global::registerPlugin:: not registering plugin ${name} (platform is ${target.platform})`);
        return;
    }
    const container = ((_a = target.Plugins) !== null && _a !== void 0 ? _a : (target.Plugins = Object.create(null)));
    const existing = container[name];
    // Allow replacing placeholder/stub entries
    if (!existing || isEmptyPlainObject(existing)) {
        container[name] = plugin;
        console.log(`global::registerPlugin: registered plugin ${name} in JWeb`);
        return;
    }
    else if (existing === plugin) {
        console.log(`global::registerPlugin: plugin ${name} already registered (same instance)`);
    }
    else {
        console.warn(`global::registerPlugin: plugin ${name} already registered with a different instance`);
    }
};
const initializeGlobal = () => {
    console.log('global::initializeGlobal');
    if (!isGlobalJWebRegistrySet()) {
        console.log('global::initializeGlobal: did not find global JWebRegistry, will set global JWebRegistry');
        setGlobalJWebRegistry({ jWebReady: getJWebReadyPromise(), registerPlugin });
    }
};
initializeGlobal();
//# sourceMappingURL=global.js.map